export default __webpack_public_path__ + "static/media/bak.df8705af.jpg";